import { useEffect, useState } from 'react';
import { changesApi } from '../../../services/changesApi';

export type IncidentTargetsState = {
  groups: Array<{ id: number; name: string }>;
  workflows: Array<{ id: number; name: string; group_ids: number[] }>;
};

const emptyTargets: IncidentTargetsState = { groups: [], workflows: [] };

export function useIncidentTargets(enabled: boolean) {
  const [targets, setTargets] = useState<IncidentTargetsState>(emptyTargets);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      setTargets(emptyTargets);
      setLoading(false);
      setError(null);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    void changesApi
      .listIncidentTargets()
      .then((payload) => {
        if (cancelled) return;
        setTargets({
          groups: payload.groups || [],
          workflows: payload.workflows || [],
        });
      })
      .catch(() => {
        if (!cancelled) {
          setTargets(emptyTargets);
          setError('Não foi possível carregar os fluxos publicados de Incidentes.');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { targets, loading, error };
}
